import classnames from 'classnames'

import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import CopyToClipboard from '../../shared/CopyToClipboard'

/**
 * One resource scope, with the permissions a client can request for it underneath.
 *
 * Each permission shows the exact name a client sends, ready to copy, since that string is what an
 * admin is usually here to find.
 */
const ScopeCard = ({scope, permissions, highlighted}) => (
  <Stack className={classnames('scope', {highlighted})}>
    <Paper className='resource' elevation={0} sx={{bgcolor: 'Background'}}>
      <Stack className='name' direction='row'>
        <Typography variant='h6'>{scope.resource}</Typography>
        {highlighted && <Chip size='small' color='primary' label='New' sx={{color: '#F7F7F7'}} />}
      </Stack>
      <Typography variant='body2'>{scope.description}</Typography>
    </Paper>
    <Box className='permissions'>
      {
        permissions.map(permission => (
          <Stack key={permission.category} className={classnames('permission', permission.category)}>
            <CopyToClipboard text={permission.name} />
            <Typography variant='body2'>{permission.description}</Typography>
          </Stack>
        ))
      }
    </Box>
  </Stack>
)

export default ScopeCard
